import ReactModal from 'react-modal'
import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { type ModalSize } from '@/features/shared/elements/Modals/types'

// Common Styles
export const BaseModalWrapper = styled(ReactModal)`
  background-color: ${({ theme }) => theme.white};
  margin: 0 auto;
  z-index: 1000001;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  outline: none !important;
  overflow: auto;
`

type ActionBarPosition = 'top' | 'bottom'
export interface ActionBarProps {
  'data-sticky'?: boolean
  'data-position'?: ActionBarPosition
}

const ActionBar = styled.div<ActionBarProps>`
  &[data-sticky='true'] {
    position: sticky;
    background-color: ${({ theme }) => theme.white};
    z-index: 10;

    &:not([data-position='bottom']) {
      top: 0;
    }

    &[data-position='bottom'] {
      bottom: 0;
    }
  }
`

// Modal Header Styles
export const HeaderActionBar = styled(ActionBar)`
  padding: 1.5rem;

  & > div {
    position: relative;
    height: 1.5rem;
  }
`

interface ActionBarContentProps {
  'data-position': 'left' | 'right'
}
export const ActionBarContent = styled.div<ActionBarContentProps>`
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  right: -0.375rem;
  top: -0.125rem;

  &[data-position='left'] {
    justify-content: flex-start;
    left: 0;
  }

  &[data-position='right'] {
    justify-content: flex-end;
  }

  button + button {
    margin-left: 0.75rem;
  }
`

// Modal Content Styles
interface ModalContentWrapperProps {
  'data-size': ModalSize
  hasHeader?: boolean
  hasFooter?: boolean
}
export const ModalContentWrapper = styled.div<ModalContentWrapperProps>`
  padding: ${({ hasHeader }) => (hasHeader ? '0' : 'var(--padding-y)')}
    var(--padding-x)
    ${({ hasFooter }) => (hasFooter ? '0' : 'var(--padding-y)')};

  &[data-size='small'] {
    --padding-y: 2.25rem;
    --padding-x: 2.25rem;
    text-align: center;
    white-space: pre-wrap;
  }

  &[data-size='medium'] {
    --padding-y: 3rem;
    --padding-x: 1.5rem;
  }

  &[data-size='large'] {
    --padding-y: 3rem;
    --padding-x: 1.5rem;
  }

  &[data-size='image'] {
    --padding-y: 2.25rem;
    --padding-x: 2.25rem;
    text-align: center;
  }

  @media ${screenSizes.tablet} {
    &[data-size='medium'] {
      --padding-x: 4.5rem;
    }

    &[data-size='large'] {
      --padding-y: 4.5rem;
      --padding-x: 4.5rem;
    }

    &[data-size='image'] {
      padding: ${({ hasHeader }) => (hasHeader ? '0' : '3rem')} 4.5rem
        ${({ hasFooter }) => (hasFooter ? '0' : '4.5rem')};
    }
  }
`

// Modal Footer Styles
export const FooterActionBar = styled(ActionBar)<{ footerAsOverlay: boolean }>`
  padding: 1.5rem 1.5rem 3rem;
  background-color: ${({ footerAsOverlay, theme }) =>
    footerAsOverlay ? 'rgba(255, 255, 255, 0.85)' : theme.white};

  @media ${screenSizes.tablet} {
    padding: 1.5rem 4.5rem 3rem;
  }
`

export const ModalButtonGroup = styled.div`
  & > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      width: 100%;
      max-width: 100%;
    }

    button + button {
      margin-top: 0.5rem;
    }
  }

  .modal-secondary-text-button {
    margin-top: 1rem;
    width: auto;
  }
`
